import { useState } from 'react'

const useActionErrorDialog = () => {
  const [errorDialogOpen, setErrorDialogOpen] = useState(false)
  const [actionError, setActionError] = useState()

  const showActionError = (error, fallbackMessage = "An unexpected error occurred.") => {
    setActionError(typeof error === "string" ? { message: error } : (error ?? { message: fallbackMessage }))
    setErrorDialogOpen(true)
  }

  return {
    actionError,
    errorDialogOpen,
    setErrorDialogOpen,
    showActionError
  }
}

export default useActionErrorDialog
